import type { DirectionDxDy } from "./DirectionDxDy.type"
import eightDirections from "./eightDirections"

export default function getDirectionFromDxDy(dx: number, dy: number): DirectionDxDy {
  for (const dir of eightDirections) {
    if (dir.dx === dx && dir.dy === dy) {
      return dir
    }
  }
  throw new Error(`getDirectionFromDxDy: no direction found for dx: ${dx}, dy: ${dy}`)
}
